/**
 * @flow
 * @author: Pavan
 */

import styled from 'react-emotion'
import { Typo13DarkGreyBlueRR, Typo13White2RR } from '../../themes/Fonts'
import { Typo12DullRedDR } from '../../themes/Fonts/Din2014'

import BaseInput from '../../commons/BaseInput'
import IconContainer from '../StyledComponents/View/IconContainer'
import Colors from '../../themes/Colors'
import { customDevice } from '../../utils/mixins'
import {
  placeholderColor,
  focussedTextColor,
  focussedBorderColor,
  textInputBackgroundColor,
  defaultDateInputWidth,
  mobileDateInputWidth
} from './themeConstants'

// DateField Styles
export const DateFieldContainer = styled('div')`
  display: flex;
  flex-direction: column;
  flex: 1;
`
export const DateInputContainer = styled('div')``

export const LabelText = styled(Typo13DarkGreyBlueRR)`
  text-align: left;
  margin-bottom: 3px;
  line-height: 1.428;
  color: ${props => {
    if (props.displayError) {
      return Colors.dullRed
    }
    return Colors.darkGreyBlue
  }};
`
export const MobileLabelText = styled(Typo13White2RR)`
  text-align: left;
  margin-bottom: 3px;
  color: ${props => {
    if (props.displayError) {
      return Colors.dullRed
    }
    return Colors.white
  }};
`

export const AbsoluteIconContainer = styled(IconContainer)`
  right: ${props => (props.rightMargin ? props.rightMargin : '17px')};
  position: absolute;
`
export const AbsoluteLeftIconContainer = styled(IconContainer)`
  left: 14px;
  position: absolute;
`

export const ErrorText = styled(Typo12DullRedDR)`
  margin-top: 5px;
  margin-bottom: 5px;
  text-align: left;
`
export const TextInputContainer = styled('div')`
  display: flex;
  align-items: center;
  box-sizing: border-box;
  position: relative;
`
export const StyledCustomInput = styled(BaseInput)`
  font-family: din-2014;
  font-size: 14px;
  background-color: ${textInputBackgroundColor};
  border-radius: 2px;
  width: ${props => {
    if (props.isMobile) {
      return `${mobileDateInputWidth}px`
    }
    return `${defaultDateInputWidth}px`
  }};
  border: ${props =>
    props.displayErrorBorder
      ? '1px solid rgb(188, 68, 68) !important'
      : 'none'};
  height: ${props => (props.height ? props.height : '38px')};
  padding-left: 37px;
  padding-right: 30px;
  outline: none;
  letter-spacing: 0.4px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  text-align: left;
  @media (min-width: 992px) and (max-width: 1352px) {
    width: 100%;
  }
  ::placeholder {
    letter-spacing: 0.4px;
    color: ${placeholderColor};
  }
  ::-moz-placeholder {
    line-height: 2.43;
    color: ${placeholderColor};
  }

  &:focus {
    outline: none;
    border: solid 1px ${focussedBorderColor};
    color: ${focussedTextColor};
    ::placeholder {
      line-height: 1.58;
      color: ${Colors.white};
    }

    :-ms-input-placeholder {
      line-height: 1.58;
      color: ${Colors.white};
    }

    ::-ms-input-placeholder {
      line-height: 1.58;
      color: ${Colors.white};
    }
  }

  ::-webkit-inner-spin-button,
  ::-webkit-outer-spin-button {
    -webkit-appearance: none;
  }
`
export const CalendarContainer = styled('div')`
  padding-left: 15px;
  padding-right: 15px;
  padding-top: 15px;
  padding-bottom: 15px;
  border-radius: 4px;
  background-color: ${Colors.white};
  ${customDevice(320, 340)} {
    padding-right: 0px;
    padding-left: 0px;
  }
  ${customDevice(341, 767)} {
    padding-right: 10px;
    padding-left: 10px;
  }
`



// WEBPACK FOOTER //
// ./src/commons/BaseDateField/styledComponents.js